import { Box, Button } from "@mui/material";
import Flex from "../../../../../components/Flex";
import StyledDialog from "../../../../../components/StyledDialog";
import Text from "../../../../../components/Text";
import {
  NO_CLEARING_HOUSE_RESPONSE,
  parseClearingHouseResponse,
} from "./claims-constants";

interface ClearingHouseResponseModalProps {
  open: boolean;
  onClose: () => void;
  /** Raw pipe-delimited response string as stored on the claim (`error`). */
  response?: string | null;
  title?: string;
}

const CLEARING_HOUSE_RESPONSE_TITLE = "Clearing House Response";
const CLOSE_LABEL = "Okay";

/**
 * Lists a clearinghouse claim response one message per line, numbered, instead
 * of the single run-on paragraph the raw pipe-delimited string reads as.
 */
const ClearingHouseResponseModal = ({
  open,
  onClose,
  response,
  title = CLEARING_HOUSE_RESPONSE_TITLE,
}: ClearingHouseResponseModalProps) => {
  const messages = parseClearingHouseResponse(response);

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      dialogTitle={title}
      PaperProps={{ sx: { width: "34rem", maxWidth: "95vw" } }}
      dialogAction={
        <Button variant="contained" onClick={onClose} sx={{ paddingX: "2rem" }}>
          {CLOSE_LABEL}
        </Button>
      }
    >
      {messages.length === 0 ? (
        <Flex justifyContent="center" sx={{ py: 2 }}>
          <Text color="text.secondary">{NO_CLEARING_HOUSE_RESPONSE}</Text>
        </Flex>
      ) : (
        <Box
          component="ol"
          sx={{
            margin: 0,
            paddingLeft: "1.5rem",
            "& li:not(:last-of-type)": { marginBottom: "10px" },
          }}
        >
          {messages.map((message, index) => (
            <li key={`${index}-${message}`}>
              <Text>{message}</Text>
            </li>
          ))}
        </Box>
      )}
    </StyledDialog>
  );
};

export default ClearingHouseResponseModal;
